import { supabase } from './supabase';

/**
 * Active members of an organisation, for the owner + member pickers.
 *
 * Two reads rather than an embed: organization_members lives in public and
 * profiles carries the display name. Both are RLS-scoped, so this returns only
 * orgs the caller belongs to — no filtering is done here, and none should be.
 *
 * The picker is a convenience. planner_set_task_assignees re-validates every
 * id server-side, so a stale or hand-edited list cannot assign a stranger.
 */
export interface MemberOption { id: string; name: string }

export async function listOrgMembers(orgId: string): Promise<MemberOption[]> {
  if (!orgId) return [];
  const { data: rows, error } = await supabase
    .from('organization_members')
    .select('user_id')
    .eq('organization_id', orgId)
    .eq('is_active', true);
  if (error || !rows?.length) return [];

  const ids = (rows as Array<{ user_id: string }>).map((r) => r.user_id);
  const { data: profiles } = await supabase
    .from('profiles').select('id, full_name').in('id', ids);

  return ((profiles ?? []) as Array<{ id: string; full_name: string | null }>)
    .map((p) => ({ id: p.id, name: p.full_name?.trim() || 'Unnamed user' }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
